var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerragram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_18_4",
    "data-name": "Component 18 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206,
    height: 46,
    viewBox: "0 0 206 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 206,
    height: 46,
    transform: "translate(23 1155)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(-23 -1155)",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_16_1",
    "data-name": "Component 16 \\u2013 1",
    transform: "translate(36.127 1161.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(-139.627 -657.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(171.003 660.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M426.544,676.189h9.244v2.293h-3.36v10.151h-2.542V678.482h-3.342Z",
    transform: "translate(-426.544 -675.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M563.788,676.189v12.444h-2.453V676.189Zm-.818,0h6.275v2.151h-6.275Zm2.392,4.782h3.528v2.115h-3.528Zm-2.392,5.511h6.275v2.151h-6.275Z",
    transform: "translate(-545.673 -675.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M696.375,676.189v12.444h-2.542V676.189Zm-1,0h2.631a5.732,5.732,0,0,1,2.507.5,3.7,3.7,0,0,1,1.582,1.387,4.184,4.184,0,0,1,0,4.151,3.68,3.68,0,0,1-1.582,1.4,5.726,5.726,0,0,1-2.507.5H695.38v-2.027h2.471a2.792,2.792,0,0,0,1.164-.222,1.708,1.708,0,0,0,.756-.64,2.025,2.025,0,0,0,0-2.009,1.712,1.712,0,0,0-.756-.64,2.8,2.8,0,0,0-1.164-.222H695.38Zm3.964,6.649,4.053,5.8h-3l-3.733-5.8Z",
    transform: "translate(-662.776 -675.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M834.075,676.189v12.444h-2.542V676.189Zm-1,0h2.631a5.733,5.733,0,0,1,2.507.5,3.7,3.7,0,0,1,1.582,1.387,4.184,4.184,0,0,1,0,4.151,3.681,3.681,0,0,1-1.582,1.4,5.727,5.727,0,0,1-2.507.5H833.08v-2.027h2.471a2.79,2.79,0,0,0,1.164-.222,1.708,1.708,0,0,0,.756-.64,2.025,2.025,0,0,0,0-2.009,1.712,1.712,0,0,0-.756-.64,2.8,2.8,0,0,0-1.164-.222H833.08Zm3.964,6.649,4.053,5.8h-3l-3.733-5.8Z",
    transform: "translate(-784.476 -675.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M962.2,678.965l.053.569-1.635,3.555h-2.862l6.311-13.173,6.311,13.173H967.5l-1.6-3.449.036-.64-1.867-4.32Zm-1.084-.711h5.973l.3,2.009h-6.578Z",
    transform: "translate(-896.034 -669.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M1116.9,680.091h6.133a8.143,8.143,0,0,1-.329,2.684,6.279,6.279,0,0,1-1.191,2.231,5.659,5.659,0,0,1-2,1.52,6.412,6.412,0,0,1-2.72.551,7.186,7.186,0,0,1-2.658-.48,6.336,6.336,0,0,1-2.115-1.351,5.985,5.985,0,0,1-1.387-2.08,7,7,0,0,1-.489-2.649,6.717,6.717,0,0,1,.507-2.64,5.97,5.97,0,0,1,1.413-2.053,6.338,6.338,0,0,1,2.133-1.316,7.507,7.507,0,0,1,2.667-.462,6.982,6.982,0,0,1,2.3.356,6.1,6.1,0,0,1,1.813.987,6.354,6.354,0,0,1,1.36,1.5l-2.169,1.262a3.633,3.633,0,0,0-1.289-1.325,3.791,3.791,0,0,0-2.017-.507,4.185,4.185,0,0,0-2.045.507,3.744,3.744,0,0,0-1.466,1.449,4.412,4.412,0,0,0-.542,2.24,4.589,4.589,0,0,0,.533,2.249,3.842,3.842,0,0,0,1.449,1.5,4.037,4.037,0,0,0,2.071.533,4.261,4.261,0,0,0,1.369-.2,3.107,3.107,0,0,0,1.04-.578,3.765,3.765,0,0,0,.738-.853,3.977,3.977,0,0,0,.462-1.049H1116.9Z",
    transform: "translate(-1030.716 -673.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M1284.351,676.189v12.444h-2.542V676.189Zm-1,0h2.631a5.733,5.733,0,0,1,2.507.5,3.7,3.7,0,0,1,1.582,1.387,4.186,4.186,0,0,1,0,4.151,3.681,3.681,0,0,1-1.582,1.4,5.728,5.728,0,0,1-2.507.5h-2.631v-2.027h2.471a2.792,2.792,0,0,0,1.164-.222,1.71,1.71,0,0,0,.756-.64,2.025,2.025,0,0,0,0-2.009,1.713,1.713,0,0,0-.756-.64,2.8,2.8,0,0,0-1.164-.222h-2.471Zm3.964,6.649,4.053,5.8h-3l-3.733-5.8Z",
    transform: "translate(-1182.434 -675.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M1412.477,678.965l.053.569-1.635,3.555h-2.862l6.311-13.173,6.311,13.173h-2.88l-1.6-3.449.036-.64-1.866-4.32Zm-1.084-.711h5.973l.3,2.009h-6.578Z",
    transform: "translate(-1293.991 -669.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M1567.66,683.9h-2.649l1.849-13.066,5.209,8.035,5.209-8.035,1.849,13.066h-2.649l-.8-6.987-3.609,5.831-3.609-5.831Z",
    transform: "translate(-1432.73 -670.727)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(-4.373 2.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M240.209,753.925v-1.679H232.5V746.53h5.959v7.395h1.75v0h1.75V743.172H229V755.6h12.959v-1.679Z",
    transform: "translate(-75.487 -78.304)",
    fill: "#f8fe55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M158.664,669.664v-1.679H147.358v-9.628h9.628v11.306h1.679v0h1.679V655H144v16.343h16.343v-1.679Z",
    transform: "translate(0)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M240.08,752.035H232.5V743H229v12.423h11.08v-3.388Z",
    transform: "translate(-75.487 -78.151)",
    fill: "#f8fe55"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Powered_by_Vegvizer",
    "data-name": "Powered by Vegvizer",
    transform: "translate(243.931 369.664)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M-117.653,821.194c0,1.342-.973,2.153-2.576,2.153h-1.692v1.989h-.666v-6.3h2.358C-118.626,819.034-117.653,819.845-117.653,821.194Zm-.667,0c0-1.007-.666-1.584-1.926-1.584h-1.675v3.151h1.675C-118.986,822.761-118.32,822.185-118.32,821.194Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M-116.854,822.968a2.329,2.329,0,0,1,2.413-2.4,2.321,2.321,0,0,1,2.4,2.4,2.329,2.329,0,0,1-2.4,2.413A2.336,2.336,0,0,1-116.854,822.968Zm4.168,0a1.726,1.726,0,0,0-1.755-1.845,1.734,1.734,0,0,0-1.765,1.845,1.733,1.733,0,0,0,1.765,1.845A1.726,1.726,0,0,0-112.686,822.968Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M-103.919,820.6l-1.791,4.735h-.6l-1.495-3.88-1.5,3.88h-.6l-1.782-4.735h.612l1.485,4.024,1.522-4.024h.549l1.513,4.024,1.5-4.024Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M-98.97,823.166h-3.961a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.36.414a2.328,2.328,0,0,1-1.827.775,2.345,2.345,0,0,1-2.485-2.413,2.28,2.28,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.295,2.4C-98.961,823.022-98.97,823.095-98.97,823.166Zm-3.961-.477h3.358a1.647,1.647,0,0,0-1.683-1.576A1.645,1.645,0,0,0-102.931,822.689Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M-95.271,820.564v.622c-.054,0-.108-.009-.153-.009a1.532,1.532,0,0,0-1.594,1.746v2.413h-.639V820.6h.612v.926A1.786,1.786,0,0,1-95.271,820.564Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M-90.042,823.166H-94a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.36.414a2.328,2.328,0,0,1-1.827.775,2.345,2.345,0,0,1-2.485-2.413,2.28,2.28,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.3,2.4C-90.033,823.022-90.042,823.095-90.042,823.166ZM-94,822.689h3.358a1.647,1.647,0,0,0-1.683-1.576A1.645,1.645,0,0,0-94,822.689Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M-84.408,818.656v6.68h-.612V824.4a2.05,2.05,0,0,1-1.828.982,2.3,2.3,0,0,1-2.359-2.413,2.292,2.292,0,0,1,2.359-2.4,2.07,2.07,0,0,1,1.8.937v-2.845Zm-.63,4.312a1.732,1.732,0,0,0-1.756-1.845,1.733,1.733,0,0,0-1.764,1.845,1.733,1.733,0,0,0,1.764,1.845A1.732,1.732,0,0,0-85.038,822.968Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M-75.471,822.968a2.3,2.3,0,0,1-2.359,2.413,2.049,2.049,0,0,1-1.827-.982v.937h-.613v-6.68h.64V821.5a2.068,2.068,0,0,1,1.8-.937A2.291,2.291,0,0,1-75.471,822.968Zm-.639,0a1.739,1.739,0,0,0-1.765-1.845,1.733,1.733,0,0,0-1.764,1.845,1.733,1.733,0,0,0,1.764,1.845A1.739,1.739,0,0,0-76.11,822.968Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M-70.323,820.6l-2.368,5.3c-.4.927-.9,1.225-1.576,1.225a1.621,1.621,0,0,1-1.152-.433l.3-.477a1.182,1.182,0,0,0,.864.36c.424,0,.712-.2.982-.792l.207-.459-2.116-4.726h.666l1.783,4.024,1.782-4.024Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M-61.692,819.034l-2.791,6.3h-.657l-2.791-6.3h.72l2.413,5.474,2.431-5.474Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M-57.156,823.166h-3.962a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.361.414a2.331,2.331,0,0,1-1.828.775,2.345,2.345,0,0,1-2.485-2.413,2.281,2.281,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.3,2.4C-57.147,823.022-57.156,823.095-57.156,823.166Zm-3.962-.477h3.358a1.647,1.647,0,0,0-1.683-1.576A1.646,1.646,0,0,0-61.118,822.689Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M-51.459,820.6v4.159a2.078,2.078,0,0,1-2.368,2.368,3.3,3.3,0,0,1-2.206-.73l.325-.486a2.818,2.818,0,0,0,1.863.649c1.2,0,1.746-.55,1.746-1.72v-.6a2.129,2.129,0,0,1-1.845.919,2.266,2.266,0,0,1-2.377-2.3,2.253,2.253,0,0,1,2.377-2.288,2.14,2.14,0,0,1,1.873.946V820.6Zm-.622,2.251a1.693,1.693,0,0,0-1.8-1.729,1.685,1.685,0,0,0-1.791,1.729,1.692,1.692,0,0,0,1.791,1.737A1.7,1.7,0,0,0-52.081,822.852Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M-45.69,820.6l-2.107,4.735h-.658l-2.1-4.735h.666l1.774,4.033,1.791-4.033Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M-44.936,819.106a.461.461,0,0,1,.468-.45A.454.454,0,0,1-44,819.1a.459.459,0,0,1-.468.468A.463.463,0,0,1-44.936,819.106Zm.144,1.495h.639v4.735h-.639Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M-39.031,824.8v.531h-3.853v-.423l2.98-3.772H-42.83v-.54h3.745v.422l-2.98,3.782Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M-33.729,823.166h-3.962a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.36.414a2.328,2.328,0,0,1-1.827.775,2.345,2.345,0,0,1-2.485-2.413,2.28,2.28,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.295,2.4C-33.721,823.022-33.729,823.095-33.729,823.166Zm-3.962-.477h3.358a1.647,1.647,0,0,0-1.683-1.576A1.645,1.645,0,0,0-37.691,822.689Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M-30.031,820.564v.622c-.054,0-.108-.009-.153-.009a1.532,1.532,0,0,0-1.594,1.746v2.413h-.639V820.6h.612v.926A1.787,1.787,0,0,1-30.031,820.564Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Powered_by_Vegvizer-2",
    "data-name": "Powered by Vegvizer",
    transform: "translate(243.209 369.664)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206-2",
    "data-name": "Group 206",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_765-2",
    "data-name": "Path 765",
    d: "M-117.653,821.194c0,1.342-.973,2.153-2.576,2.153h-1.692v1.989h-.666v-6.3h2.358C-118.626,819.034-117.653,819.845-117.653,821.194Zm-.667,0c0-1.007-.666-1.584-1.926-1.584h-1.675v3.151h1.675C-118.986,822.761-118.32,822.185-118.32,821.194Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_766-2",
    "data-name": "Path 766",
    d: "M-116.854,822.968a2.329,2.329,0,0,1,2.413-2.4,2.321,2.321,0,0,1,2.4,2.4,2.329,2.329,0,0,1-2.4,2.413A2.336,2.336,0,0,1-116.854,822.968Zm4.168,0a1.726,1.726,0,0,0-1.755-1.845,1.734,1.734,0,0,0-1.765,1.845,1.733,1.733,0,0,0,1.765,1.845A1.726,1.726,0,0,0-112.686,822.968Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_767-2",
    "data-name": "Path 767",
    d: "M-103.919,820.6l-1.791,4.735h-.6l-1.495-3.88-1.5,3.88h-.6l-1.782-4.735h.612l1.485,4.024,1.522-4.024h.549l1.513,4.024,1.5-4.024Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_768-2",
    "data-name": "Path 768",
    d: "M-98.97,823.166h-3.961a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.36.414a2.328,2.328,0,0,1-1.827.775,2.345,2.345,0,0,1-2.485-2.413,2.28,2.28,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.295,2.4C-98.961,823.022-98.97,823.095-98.97,823.166Zm-3.961-.477h3.358a1.647,1.647,0,0,0-1.683-1.576A1.645,1.645,0,0,0-102.931,822.689Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_769-2",
    "data-name": "Path 769",
    d: "M-95.271,820.564v.622c-.054,0-.108-.009-.153-.009a1.532,1.532,0,0,0-1.594,1.746v2.413h-.639V820.6h.612v.926A1.786,1.786,0,0,1-95.271,820.564Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_770-2",
    "data-name": "Path 770",
    d: "M-90.042,823.166H-94a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.36.414a2.328,2.328,0,0,1-1.827.775,2.345,2.345,0,0,1-2.485-2.413,2.28,2.28,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.3,2.4C-90.033,823.022-90.042,823.095-90.042,823.166ZM-94,822.689h3.358a1.647,1.647,0,0,0-1.683-1.576A1.645,1.645,0,0,0-94,822.689Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_771-2",
    "data-name": "Path 771",
    d: "M-84.408,818.656v6.68h-.612V824.4a2.05,2.05,0,0,1-1.828.982,2.3,2.3,0,0,1-2.359-2.413,2.292,2.292,0,0,1,2.359-2.4,2.07,2.07,0,0,1,1.8.937v-2.845Zm-.63,4.312a1.732,1.732,0,0,0-1.756-1.845,1.733,1.733,0,0,0-1.764,1.845,1.733,1.733,0,0,0,1.764,1.845A1.732,1.732,0,0,0-85.038,822.968Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_772-2",
    "data-name": "Path 772",
    d: "M-75.471,822.968a2.3,2.3,0,0,1-2.359,2.413,2.049,2.049,0,0,1-1.827-.982v.937h-.613v-6.68h.64V821.5a2.068,2.068,0,0,1,1.8-.937A2.291,2.291,0,0,1-75.471,822.968Zm-.639,0a1.739,1.739,0,0,0-1.765-1.845,1.733,1.733,0,0,0-1.764,1.845,1.733,1.733,0,0,0,1.764,1.845A1.739,1.739,0,0,0-76.11,822.968Z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_773-2",
    "data-name": "Path 773",
    d: "M-70.323,820.6l-2.368,5.3c-.4.927-.9,1.225-1.576,1.225a1.621,1.621,0,0,1-1.152-.433l.3-.477a1.182,1.182,0,0,0,.864.36c.424,0,.712-.2.982-.792l.207-.459-2.116-4.726h.666l1.783,4.024,1.782-4.024Z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_774-2",
    "data-name": "Path 774",
    d: "M-61.692,819.034l-2.791,6.3h-.657l-2.791-6.3h.72l2.413,5.474,2.431-5.474Z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_775-2",
    "data-name": "Path 775",
    d: "M-57.156,823.166h-3.962a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.361.414a2.331,2.331,0,0,1-1.828.775,2.345,2.345,0,0,1-2.485-2.413,2.281,2.281,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.3,2.4C-57.147,823.022-57.156,823.095-57.156,823.166Zm-3.962-.477h3.358a1.647,1.647,0,0,0-1.683-1.576A1.646,1.646,0,0,0-61.118,822.689Z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_776-2",
    "data-name": "Path 776",
    d: "M-51.459,820.6v4.159a2.078,2.078,0,0,1-2.368,2.368,3.3,3.3,0,0,1-2.206-.73l.325-.486a2.818,2.818,0,0,0,1.863.649c1.2,0,1.746-.55,1.746-1.72v-.6a2.129,2.129,0,0,1-1.845.919,2.266,2.266,0,0,1-2.377-2.3,2.253,2.253,0,0,1,2.377-2.288,2.14,2.14,0,0,1,1.873.946V820.6Zm-.622,2.251a1.693,1.693,0,0,0-1.8-1.729,1.685,1.685,0,0,0-1.791,1.729,1.692,1.692,0,0,0,1.791,1.737A1.7,1.7,0,0,0-52.081,822.852Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_777-2",
    "data-name": "Path 777",
    d: "M-45.69,820.6l-2.107,4.735h-.658l-2.1-4.735h.666l1.774,4.033,1.791-4.033Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_778-2",
    "data-name": "Path 778",
    d: "M-44.936,819.106a.461.461,0,0,1,.468-.45A.454.454,0,0,1-44,819.1a.459.459,0,0,1-.468.468A.463.463,0,0,1-44.936,819.106Zm.144,1.495h.639v4.735h-.639Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_779-2",
    "data-name": "Path 779",
    d: "M-39.031,824.8v.531h-3.853v-.423l2.98-3.772H-42.83v-.54h3.745v.422l-2.98,3.782Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_780-2",
    "data-name": "Path 780",
    d: "M-33.729,823.166h-3.962a1.753,1.753,0,0,0,1.864,1.647,1.866,1.866,0,0,0,1.449-.621l.36.414a2.328,2.328,0,0,1-1.827.775,2.345,2.345,0,0,1-2.485-2.413,2.28,2.28,0,0,1,2.314-2.4,2.257,2.257,0,0,1,2.295,2.4C-33.721,823.022-33.729,823.095-33.729,823.166Zm-3.962-.477h3.358a1.647,1.647,0,0,0-1.683-1.576A1.645,1.645,0,0,0-37.691,822.689Z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_781-2",
    "data-name": "Path 781",
    d: "M-30.031,820.564v.622c-.054,0-.108-.009-.153-.009a1.532,1.532,0,0,0-1.594,1.746v2.413h-.639V820.6h.612v.926A1.787,1.787,0,0,1-30.031,820.564Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerragram);
export default __webpack_public_path__ + "static/media/terragram.1f06e38e0b1ba02659ba1e381651f2c1.svg";
export { ForwardRef as ReactComponent };